import { useParams } from "react-router-dom";
const ExpiredPage: React.FC = () => {
  const { locale } = useParams();

  const handleForgotPasswordBtnClick = () => {
    window.location.href = `/${locale}/forgot-password`;
  };

  return (
    <div className="expired-reset-password">
      <div className="wiley-forgotPasswordHeader">
        <h1 className="wiley-forgotPasswordHeading">Reset Password</h1>
        <div className="wiley-forgotPasswordSubHeading">
          The link to reset your password has expired. To request a new link,
          please go to the Forgot Password page.
        </div>
      </div>
      <button
        className="expired-reset-password-btn"
        id="wiley-forgotPasswordSubmitBtn"
        onClick={handleForgotPasswordBtnClick}
      >
        <span className="wileyCommonBtnText">Forgot Password</span>
      </button>
    </div>
  );
};

export default ExpiredPage;
